<template>
  <div class="container category" :class="{ containerPadding: $route.query.type !== 'inside' }">
    <follow @follow="followFn"></follow>
    <div class="Header" :style="follow ? { top: '0.5rem' } : { top: '0' }">
      <ul>
        <li
          :class="{ navColor: headerIndex == index }"
          v-for="(item, index) of nav"
          @click="headerClick(index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="feature flex-ac">
        <div class="search flex-1 flex-js-ac" @click="searchClick">
          <div class="inp">{{ defaultSearch ? '搜索“' + defaultSearch + '”' : '' }}</div>
          <div class="searchBtn f14">
            <van-icon name="search" color="#ffffff" size="0.2rem" />
            搜索
          </div>
        </div>
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
        </div>
      </div>
    </div>
    <div
      v-if="headerIndex == 0"
      id="cup"
      class="flex"
      :style="follow ? { 'margin-top': '0.97rem' } : { 'margin-top': '0.9rem' }"
    >
      <van-sidebar class="flex-s" v-model="activeKey">
        <div style="background: #ffffff">
          <van-sidebar-item
            :index="index"
            :activeKey="activeKey"
            :class="{ radius_t: index == activeKey - 1, radius_b: index == activeKey + 1 }"
            v-for="(item, index) of categoryList"
            :key="index"
            :title="item.sortName"
          />
        </div>
      </van-sidebar>
      <div class="actregion" style="background: #ffffff">
        <category_act-item
          v-if="itemlist && itemlist.sortName"
          :cateItem="itemlist"
          :markButtonCodeData="{
            buttontext: itemlist.sortName ? itemlist.sortName : '',
            buttonCode: headerIndex == 1 ? 'classify' : 'category'
          }"
        ></category_act-item>
        <div
          class="categoryList"
          v-if="itemlist && itemlist.subSortList && itemlist.subSortList.length"
        >
          <categoryItem
            v-for="(item, index) in itemlist.subSortList"
            :key="index"
            :markButtonCodeData="{
              buttontext: itemlist.sortName ? itemlist.sortName : '',
              buttonCode: headerIndex == 1 ? 'classify' : 'category'
            }"
            :cateItem="item"
            :type="0"
            :widthspan="8"
          ></categoryItem>
        </div>
      </div>
    </div>
    <div
      v-else
      id="cup"
      :style="follow ? { 'margin-top': '0.95rem' } : { 'margin-top': '0.88rem' }"
    >
      <div class="categoryContent">
        <div
          class="skinTest"
          v-if="itemlist && itemlist.length > 0 && $store.state.skinTextCategoryShow == 1"
        >
          <skinTest :page="'category'"></skinTest>
        </div>
        <div class="categoryList" v-if="itemlist && itemlist.length">
          <categoryItem
            :cateItem="itemlist"
            :key="index"
            :markButtonCodeData="{ buttonCode: headerIndex == 1 ? 'classify' : 'category' }"
            :type="1"
            :widthspan="6"
          ></categoryItem>
        </div>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <div v-if="$route.query.type !== 'inside'">
      <footer-comp :footerIndex="index" :cartnum="cartnum"></footer-comp>
    </div>
  </div>
</template>

<script>
import skinTest from '../common/skinTest'
import advertisingSpace from '../common/advertisingSpace'
import categoryItem from './categoryItem'
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import { customRequestAjax } from '@/axiosApi'
import {
  isWeixin,
  fenxiang,
  kefu,
  Base64,
  cartNum,
  goXcxCreateBtnFn,
  clickburiedPoint
} from '../../assets/common/js/config'
import category_actItem from './category_actItem'
import Vue from 'vue'
Vue.config.ignoredElements = ['wx-open-launch-weapp']

export default {
  name: 'category',
  data() {
    return {
      index: 1,
      defaultSearch: '',
      categoryList: [],
      itemlist: null,
      follow: null,
      cartnum: 0,
      nav: ['分类', '系列'],
      headerIndex: 0,
      activeKey: 0,
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  components: {
    skinTest,
    categoryItem,
    footerComp,
    follow,
    advertisingSpace,
    category_actItem
  },
  watch: {
    activeKey() {
      this.itemlist = null
      setTimeout(() => {
        this.itemlist = this.categoryList[this.activeKey]
        this.$nextTick(() => {
          setTimeout(() => {
            goXcxCreateBtnFn(this)
          }, 500)
        })
      })
    }
  },
  mounted: function () {
    if (!isWeixin()) {
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$store.commit('SKIN_PATH', 'classification')
        if (this.$route.query.type !== 'inside') {
          this.$store.commit('PATH_VALUE', '')
        }
      }
    } else {
      var base = new Base64()
      fenxiang({
        type: 'list',
        dataStr: 'type=list&params=' + base.encode(JSON.stringify({ type: 'inside' })),
        path: 'category'
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.getData()
      })
    } else {
      next((vm) => {
        cartNum((num) => (vm.cartnum = num))
        vm.getData()
        // setTimeout(function () {
        //   window.scrollTo(0, sessionStorage.askPositon, false)
        // }, 0) // 同步转异步操作
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    next()
  },
  methods: {
    getData: function () {
      clickburiedPoint({
        data: {
          buttonCode: this.headerIndex == 1 ? 'classify' : 'category',
          buttontext: this.nav[this.headerIndex]
        }
      })
      if (this.headerIndex == 0) {
        this.getData0()
      } else {
        this.getData1()
      }
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getData0: function () {
      // sessionStorage.removeItem('isLocationMaiList') // 记录刷新一次
      var url = 'Wxmall/Market/getMarketNaviList'
      var that = this
      customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.categoryList = res.data.sortList
            setTimeout(() => {
              this.itemlist = this.categoryList[this.activeKey]
              this.$nextTick(() => {
                setTimeout(() => {
                  goXcxCreateBtnFn(this)
                }, 500)
              })
            })
            if (res.data.default_search) {
              that.defaultSearch = res.data.default_search
            } else {
              that.defaultSearch = that.$store.state.defaultSearch
                ? that.$store.state.defaultSearch
                : ''
            }
          }
        })
        .catch((err) => {})
    },
    getData1: function () {
      // sessionStorage.removeItem('isLocationMaiList') // 记录刷新一次
      var url = 'Wxmall/Market/getSeriesNaviList'

      var that = this
      customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.categoryList = res.data.list
            that.itemlist = null
            setTimeout(() => {
              that.itemlist = that.categoryList
              that.$nextTick(() => {
                setTimeout(() => {
                  goXcxCreateBtnFn(that)
                }, 500)
              })
            })
            if (res.data.default_search) {
              that.defaultSearch = res.data.default_search
            } else {
              that.defaultSearch = that.$store.state.defaultSearch
                ? that.$store.state.defaultSearch
                : ''
            }
          }
        })
        .catch((err) => {})
    },
    headerClick: function (idx) {
      window.scrollTo(0, 0)
      if (this.headerIndex == idx) return
      this.headerIndex = idx
      this.categoryList = []
      this.getData()
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    followFn: function (data) {
      this.follow = data
    },
    searchClick: function () {
      this.$router.push('/search')
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  /*overflow: hidden;*/
  height: 100%;
  flex: 0;
  -webkit-flex: 0;
  -moz-flex: 0;
  -ms-flex: 0;
  -o-flex: 0;
  .Header {
    background: #fff;
    padding: 0 0.11rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    ul {
      height: 0.44rem;
      font-size: 0;
      flex: 1;
      text-align: center;
      li {
        display: inline-block;
        font-size: 0.17rem;
        color: #222222;
        margin-right: 0.67rem;
        transition: all 0.2s;
        margin-top: 0.1rem;
        &:first-of-type {
          margin-left: -0.2rem;
        }
        &:last-of-type {
          margin-right: -0.2rem;
        }
        &.navColor0 {
          color: #ffffff;
        }
        &.navColor {
          color: #fe0f41;
          font-weight: 600;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            width: 0.26rem;
            height: 0.03rem;
            background: linear-gradient(90deg, #fc0324 0%, #fc0324 100%);
          }
        }
      }
    }
    .feature {
      height: 0.44rem;
      .search {
        /*width: 3.23rem;*/
        margin-right: 0.1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.13rem;
        background: #ffffff;
        border-radius: 0.15rem;
        border: 0.01rem solid #fc0324;
        color: #999999;
        position: relative;
        .searchicon {
          font-size: 0;
          position: absolute;
          width: 0.2rem;
          height: 0.2rem;
          left: 0.1rem;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          /*overflow: hidden;*/
          .van-icon-search {
            color: transparent;
            font-weight: 600;
            font-size: 0.2rem;
            height: 100%;
            background: url('../../assets/images/search3.png') no-repeat center;
            background-size: 100%;
          }
        }
        .inp {
          border: 0.01rem solid transparent;
          background: transparent;
          border-radius: 0.15rem;
          height: 0.3rem;
          line-height: 0.3rem;
          padding-left: 0.1rem;
          font-size: 0.13rem;
          color: #999999;
          -webkit-transition: all 0.35s;
          transition: all 0.35s;
          margin-right: 0.1rem;
        }
        .searchBtn {
          color: #ffffff;
          background: linear-gradient(92deg, #fc0324 0%, #f63a66 100%);
          border-radius: 0.15rem;
          flex-wrap: nowrap;
          padding: 0 0.12rem;
          height: 0.29rem;
          line-height: 0.3rem;
          .van-icon-search {
            position: initial;
            background: none;
            transform: translateY(0);
            vertical-align: middle;
            margin-right: 0.02rem;
          }
        }
      }
      .kefu {
        float: right;
        img {
          margin-top: 0.03rem;
          width: 0.2rem;
          height: 0.2rem;
        }
      }
    }
  }
  #cup {
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    height: calc(100% - 0.88rem - 0.56rem);
    /*overflow-y: auto;*/
    /*padding-bottom: .5rem;*/
  }
  .van-sidebar {
    height: 100%;
    width: 28.6%;
    background: #f5f5f5;
    .van-sidebar-item--select::before {
      background: #ffffff;
    }
    .van-sidebar-item {
      text-align: center;
      font-size: 0.14rem;
      padding: 0.16rem 0;
      background: #f5f5f5;
    }
    .van-sidebar-item--select {
      color: #fc0324;
      font-size: 0.17rem;
      font-weight: normal;
      background: #ffffff;
    }
    .radius_t {
      border-radius: 0 0 0.12rem 0;
    }
    .radius_b {
      border-radius: 0 0.12rem 0 0;
    }
  }
  .actregion {
    width: 71.4%;
    height: 100%;
    overflow-y: auto;
    .categoryList {
      padding: 0;
    }
  }
  .skinTest {
    margin-top: 0.1rem;
  }
  .categoryList {
    background: #ffffff;
    margin: 0.1rem 0;
    padding: 0.17rem 0 0;
    border-radius: 0.08rem;
  }
  .categoryContent {
    height: calc(100%);
    overflow-y: auto;
    .categoryList {
      min-height: calc(100% - 0.22rem);
    }
    /*padding-top: 0.44rem;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/category/category.vue